import React, { useRef } from "react"

import { useCallBackOnVisible } from "./hooks/use-is-visible"

interface Props {
    readonly children: React.ReactNode
    readonly onViewed: () => void
    readonly delay?: number
}

export default function ViewObserverContainer({
    children,
    onViewed,
    delay = 0,
}: Props) {
    const ref = useRef<HTMLDivElement>(null)

    useCallBackOnVisible({
        callback: () => setTimeout(onViewed, delay),
        canaryRef: ref,
    })

    return <div ref={ref}>{children}</div>
}
